import { useTranslation } from 'react-i18next';
import { isApiError } from './api-error';

/** Turns any failure into a translated sentence. Technical errors never reach the user (§12). */
export function useErrorMessage(): (error: unknown) => string {
  const { t, i18n } = useTranslation();
  return (error: unknown) => {
    if (isApiError(error)) {
      if (i18n.exists(error.messageKey)) return t(error.messageKey);
      return t(error.categoryKey);
    }
    return t('errors.categories.internal');
  };
}
